const DashboardActiveOrganizations = ({ active, inActive}) => {
    return (
        <div className="w-full md:h-1/4 flex justify-center items-center xl:text-base md:text-[11px] text-sm bg-[#2d3347]"
            style={{
                borderRadius: 16,
                padding: '10px 24px 10px 24px',
                boxShadow: '0 2px 8px #0002',
                gap: 12
            }}>
            <div className="flex flex-col items-center gap-2" style={{ width: '100%', textAlign: 'center', fontWeight: 700, color: '#fff', alignItems: 'center', padding: '0 8px' }}>
                <span className="lg:text-sm text-[9px]">{'المفعل'}</span>
                <span className="rounded-full w-12 h-12 flex justify-center items-center text-xl" style={{ fontWeight: 900, color: "black", backgroundColor: '#22c55e' }}>{String(active).padStart(2, '0')}</span>
            </div>
            <div className="flex flex-col items-center gap-2" style={{ width: '100%', textAlign: 'center', fontWeight: 700, color: '#fff', alignItems: 'center', padding: '0 8px' }}>
                <span className="lg:text-sm text-[9px]">{'الغير مفعّل'}</span>
                <span className="rounded-full w-12 h-12 flex justify-center items-center text-xl" style={{ fontWeight: 900, color: "black", backgroundColor: '#ef4444' }}>{String(inActive).padStart(2, '0')}</span>
            </div>
            <div className="flex flex-col items-center gap-2" style={{ width: '100%', textAlign: 'center', fontWeight: 700, color: '#fff', alignItems: 'center', padding: '0 8px' }}>
                <span className="lg:text-sm text-[9px]">{'إجمالي'}</span>
                <span className="rounded-full w-12 h-12 flex justify-center items-center text-xl" style={{ fontWeight: 900, color: "black", backgroundColor: '#3fd8ff' }}>{String(active).padStart(2, '0')}</span>
            </div>
        </div>
    )
};

export default DashboardActiveOrganizations;